import { ErrorObject } from "../../../../services/base-http.service";

export class ErrorMessage {
  active = false;
  hide = false;
  errorObject: ErrorObject;
}
